export default __webpack_public_path__ + "static/media/wh_ep1_tutorial_001.9951df16.jpg";